import config from '@/helpers/config/index';
import PricePrinter from './_helper';

const pricePrinter = new PricePrinter(config.project);

export default  {
    methods: {
        printPrice(price) {
            return pricePrinter.print(price); 
        }
    }
} 